import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConsultingPage = lazy(() => import('../pages/services/consulting/page'));
const CashlessPage = lazy(() => import('../pages/services/cashless/page'));
const CSRPage = lazy(() => import('../pages/csr/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const CaseStudyPage = lazy(() => import('../pages/case-study/page'));
const CaseStudyCashlessPage = lazy(() => import('../pages/case-study/cashless/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/consulting',
    element: <ConsultingPage />,
  },
  {
    path: '/services/cashless',
    element: <CashlessPage />,
  },
  {
    path: '/csr',
    element: <CSRPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/case-study',
    element: <CaseStudyPage />,
  },
  {
    path: '/case-study/cashless',
    element: <CaseStudyCashlessPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
